module.exports = __webpack_public_path__ + "img/sleeping-bot-avatar.f527eb6e.png";